module.exports = __webpack_public_path__ + "files/abdb2192647beacdf2f731232cc64ccc.png";